import { environment } from '../../../environments/environment';
declare function require(name: string);
const productRouteConfig = require(`../../../assets/${environment.client_folder}/json/product-config.json`);
const sba = productRouteConfig['sbaloans']['route']
  ? productRouteConfig['sbaloans']['route'] + '/'
  : '';
const nonsba = productRouteConfig['businessloans']['route']
  ? productRouteConfig['businessloans']['route'] + '/'
  : '';
const common = productRouteConfig['common']['route']
  ? productRouteConfig['common']['route'] + '/'
  : '';

const UNRESOLVED_ROUTES = {
  invalid_session_redirect: ``,
  'owner-sba-form-1': `../sba-form-1`,
  'owner-sba-form-2': `../sba-form-2`,
  'owner-sba-form-3': `../sba-form-3`,
  'owner-sba-form-4': `../sba-form-4`,
  'owner-sba-form-5': `../sba-form-5`,
  'owner-sba-form-6': `../sba-form-6`,
  'owner-sba-form-7': `../sba-form-7`,
  'owner-sba-form-8': `../sba-form-8`,
  'sba-form-complete': `../sba-form-complete`,
};

const COMMON_ROUTES = {
  thankyou: `${common}thankyou`,
  signin: `/${common}login`,
  'get-started': `/${common}get-started`,
  'select-industry': `/${common}get-started/select-industry`,
  'select-business-structure': `/${common}get-started/select-business-structure`,
  'create-profile': `/${common}get-started/create-profile`,
  'reset-password': `/${common}reset-password`,
  'change-password': `/${common}change-password`,
  dashboard: `/${common}welcome`,
  'user-redirect': `/${common}user-redirect`,
  'otp-modal': `/${common}otp-modal`
};

const SBA_ROUTES = {
  
};

const NON_SBA_ROUTES = {
  'gross-sales': `/${nonsba}business-details`,
  'about-business': `/${nonsba}business-details/about-business`,
  'owner-details': `/${nonsba}owner-details`,
  'mag-owner-details': `/${nonsba}mag-owner-details`,
  'recap': `/${nonsba}recap`,
  'another-owner-detail': `/${nonsba}owner-details/business-info`,
  'consent-received': `/${nonsba}owner/verification/consent-received`,
  'mag-consent-received': `/${nonsba}owner/mag-verification/mag-consent-received`,
  'financial-information': `/${nonsba}owner-details/financial-info`,
  'borrower-information': `/${nonsba}owner-details/borrower-info`,
  'borrower-eligibility': `../${nonsba}borrower-eligibility`,
  'affiliate-information': `/${nonsba}owner-details/affiliate-info`,
  'term-sheet': `/${nonsba}owner-details/term-sheet`,
  'loan-type': `/${nonsba}loan-information`,
  'choose-your-product': `/${nonsba}choose-your-product`,
  'eligible-offer': `/${nonsba}eligible-offer`,
  'otp-modal': `/${nonsba}otp-modal`,
  documents: `/${nonsba}documents`,
  'owner-documents': `../${nonsba}documents/additional`,
  'document-complete': `../${nonsba}doc-complete`,
  'owner-documents-business': `../${nonsba}documents/additional`,
  'document-complete-business': `../${nonsba}documents/doc-complete`,
  'application-submit': `../${nonsba}application-submit`,
  'collateral-details': `/${nonsba}collateral-details`,
  'collateral-details-form': `/${nonsba}collateral-details/form`,
  'funding-information': `/${nonsba}funding-information/account-info`,
  'application-complete': `/${nonsba}thank-you`,
  finish: `/${nonsba}thank-you/completed`,
  'pfs-form': `/${nonsba}pfs-form`,
  'pfs-form-additonal': `../../pfs-form/additional-pfs`,
  'document-additonal': `../documents/additional`,
  'document-additional-link': `../../documents-pfs/additional`,
  'doc-pfs-thanks': `../../thank-you/doc-pfs-thanks`,
  'pfs-thanks': '../thank-you/pfs-thanks',
  'document-complete-hash': `../../thank-you/doc-thanks`,
  'pfs-individual-complete': `../../thank-you/doc-pfs-thanks`,
  'doc-thanks': '../../thank-you/doc-thanks',
  'connect-banker':`/${nonsba}connect-banker`,
  'business-debt-schedule' : `/${nonsba}business-debt-schedule`,
  'learn-video': `/${nonsba}learn-video`,
  'select-amount': `/${nonsba}select-amount`,
  'select-bank': `/${nonsba}select-bank`,
  'select-tenure': `/${nonsba}select-tenure`,
  'no-offer': `/${nonsba}no-offer`,
  'clientUrl': `/${nonsba}user-redirect/clientUrl`,
  'verify-otp': `/${nonsba}otp/verify`,
};

const PATH_RESOLVER = {
  [sba]: {},
  [nonsba]: {},
};

export const CONSTANTS = {
  PATH_RESOLVER: {
    ...PATH_RESOLVER,
  },
  FOOTER_CONGIF: {
    footer_text: environment.copyright_text,
  },
  CLIENT_CONFIG: {
    title: environment.title,
    name: environment.client_name,
    project_name: environment.project_name,
    addressl: environment.client_addressl,
    city: environment.client_city,
    state: environment.client_state,
    country: environment.client_country,
    zipcode: environment.client_zipcode,
    clientNumber: environment.client_number,
    client_url: environment.client_url,
    privacy_url: environment.privacy,
    siteMap_url: environment.siteMap,
    terms_url: environment.terms,
    no_reply_mail: environment.noreplymail,
    emailId: environment.client_email,
  },

  APP_ROUTES: {
    ...UNRESOLVED_ROUTES,
    ...COMMON_ROUTES,
    ...SBA_ROUTES,
    ...NON_SBA_ROUTES,
  },

  APP_STEP: {
    // 'loan-type': 1,
    // // 'create-profile': 1,
    // 'about-business': 2,
    // // 'borrower-eligibility': 3,
    // // 'check_acct_eligib_quest': 3,
    // 'owner-details': 3,
    // 'mag-owner-details':3,
    // 'another-owner-detail': 3,
    // all_owners_detail: 3,
    // // 'financial-information': 5,
    // // 'affiliate-information': 4,
    // // 'collateral-details': 5,
    // // 'business-debt-schedule': 4,
    // documents: 4,
    // // 'funding-information': 6,
    // 'pfs-form': 7,

    // 'loan-type': 1,
    // 'create-profile': 1,
    // 'about-business': 2,
    // 'borrower-eligibility': 3,
    // 'check_acct_eligib_quest': 3,
    // 'owner-details': 2,
    'mag-owner-details':2,
    // 'another-owner-detail': 2,
    // all_owners_detail: 3,
    // 'financial-information': 5,
    // 'affiliate-information': 4,
    // 'collateral-details': 5,
    // 'business-debt-schedule': 4,
    documents: 3,
    // 'funding-information': 6,
    'pfs-form': 7,
  },

  SLUG: {
    'borrower-eligibility': 'borrower-eligibility',
    'ui-component':'ui-component',
    configuration: 'configuration',
    signin: 'signin',
    'get-started': 'get-started',
    'create-profile': 'create-profile',
    'select-industry': 'select-industry',
    'select-business-structure': 'select-business-structure',
    'loan-type': 'loan-type',
    'owner-details': 'owner-details',
    'mag-owner-details':'mag-owner-details',
    'mag-business-details':'mag-business-details',
    'another-owner-detail': 'another-owner-detail',
    'financial-information': 'financial-information',
    'borrower-information': 'borrower-information',
    'affiliate-information': 'affiliate-information',
    'term-sheet': 'term-sheet',
    'delete-owner': 'delete-owner',
    'application-progress': 'application-progress',
    'gross-sales': 'gross-sales',
    'about-business': 'about-business',
    'forget-password': 'forget-password',
    'otp-verification': 'otp-verification',
    'resend-otp': 'resend-otp',
    'change-password': 'change-password',
    'reset-password': 'reset-password',
    dashboard: 'dashboard',
    documents: 'documents',
    request_owners_consent: 'request_owners_consent',
    'verify-owner-consent': 'verify-owner-consent',
    'verify-mag-owner-consent': 'verify-mag-owner-consent',
    create_new_application: 'create_new_application',
    'sba-form-1': 'sba-form-1',
    'sba-form-2': 'sba-form-2',
    'sba-form-3': 'sba-form-3',
    'sba-form-4': 'sba-form-4',
    'sba-form-5': 'sba-form-5',
    'sba-form-6': 'sba-form-6',
    'sba-form-8': 'sba-form-8',
    'sba-form-7': 'sba-form-7',
    verify_owner_hash: 'verify_owner_hash',
    reply_uw_request: 'reply_uw_request',
    pfs_assets_and_liabilities: 'pfs_assets_and_liabilities',
    schedule_cash: 'schedule_cash',
    restricted_cash: 'restricted_cash',
    non_marketable_securities: 'non_marketable_securities',
    marketable_securities: 'marketable_securities',
    account_taxes_receivable: 'account_taxes_receivable',
    account_taxes_payable: 'account_taxes_payable',
    real_estate_details: 'real_estate_details',
    contingent_liabilities: 'contingent_liabilities',
    'get-business-data': 'get-business-data',
    'documents-end': 'documents-end',
    post_form_1919: 'post_form_1919',
    download_pdf: 'download_pdf',
    'force-change-password': 'force-change-password',
    agreed_terms_and_condition: 'agreed_terms_and_condition',
    'banker-by-ids': 'banker-by-ids',
    'get-stages-actions': 'get-stages-actions',
    'update_owner': 'update_owner',
    document_widget_data: 'document-widget-data',
    get_backend_users: 'get_backend_users',
    requested_documents: 'requested-documents',
    application_pdf_master: 'application_pdf_master',
    withdraw_application: 'withdraw_application',
    encrypt_check_login_token: 'encrypt_check_login_token',
    auto_login: 'auto_login',
    'term-sheet-decline': 'term-sheet-decline',
    request_pfs: 'request_pfs',
    'get-application': 'get-application',
    'ach-data': 'ach-data',
    'no-debt-list': 'no-debt-list',
    'term-sheet-mail': 'term-sheet-mail',
    'ifs-data': 'ifs-data',
    all_owners_detail: 'all_owners_detail',
    add_child_owners: 'add_child_owners',
    'ifs-document': 'ifs-document',
    'sba-primary': 'sba-primary',
    'application-submit': 'application-submit',
    'collateral-details': 'collateral-details',
    'funding-information': 'funding-information',
    'pfs-form': 'pfs-form',
    'connect_banker_customer':'connect_banker_customer',
    life_insurance: 'life_insurance',
    other_liabilities: 'other_liabilities',
    spouse_details: 'spouse_details',
    account_payable: 'account_payable',
    stocks_and_bonds: 'stocks_and_bonds',
    notes_payable: 'notes_payable',
    real_estate_owned: 'real_estate_owned',
    contingent_income: 'contingent_income',
    other_personal_property_assets: 'other_personal_property_assets',
    installment_account: 'installment_account',
    'pfs-form-additonal': 'pfs-form-additonal',
    update_application_status: 'update_application_status',
    'beneficial-information': 'beneficial-information',
    source_of_income: 'source_of_income',
    unpaid_taxes: 'unpaid_taxes',
    loan_against_life_insurance: "loan_against_life_insurance",
    'pfs-pdf': 'pfs-pdf',
    'add-edit-affiliate-info' : 'add-edit-affiliate-info',
    'business-debt-schedule' : 'business-debt-schedule',
    'act_get_notes':'act_get_notes',
    'stock-questions-combined': 'stock-questions-combined',
    "app_detail_optimized": "app_detail_optimized",
    'eligible_offer':'eligible_offer',
    'create_app':'create_app',
    'get-user': 'get-user',
    'update_app_products': 'update_app_products',
    'send-welcome-mail': 'send-welcome-mail',
    'select_amount': 'select_amount',
    'select-tenure': 'select-tenure',
    'get-metadata-tenant':'get-metadata-tenant',
    'update_notes': 'update_notes',
    'loan_renewal': 'loan-renewal',
    'get_business_data': 'get_business_data',
    'update_business_current_state': 'update_business_current_state'
  },

  APPLICATION_STATUS: {
    application_in_progress: '5c20bf7e27105c78ad7f9289',
    application_completed: '5c20bf7e27105c78ad7f9281',
    application_soft_decline: '5c20bf7e27105c78ad7f928a',
    application_hard_decline: '5c20bf7e27105c78ad7f928b',
    app_hard_withdrawn: '5c20bf7e27105c78ad7f928d',
    app_soft_withdrawn: '5c20bf7e27105c78ad7f928c',
    app_submitted: '5c20bf7e27105c78ad7f9282',
    // 'app_submitted': '5c20bf7e27105c78ad7f9281'
  },

  WITHDRAW_SUB_STATUS: {
    relationship_manager: '60cf9e1cf49aab0d7ca97f1f',
    loan_officer: '60cf9e1cf49aab0d7ca97f1f',
    fulfillment_services: '60cf9e1cf49aab0d7ca97f25',
  },

  MAIL_TEMPLATE: {
    copyright_text: environment.copyright_text,
    senders_name: environment.mail_client_name,
    project_name: environment.project_name,
    no_reply_mail: environment.noreplymail,
  },

  // SMS_TEMPLATE: {
  //   ISD_CODE_FOR_SMS_TRIGGER: environment.isd_code_for_sms_trigger,
  //   SMS_BODY_TEXT: environment.sms_body_text,
  //   SMS_BODY_TEXT_MITEK:"Hello, Thanks for choosing  for your finance needs. Please complete your ID verification on your phone,",
  //   SMS_GENERAL_TEXT: environment.sms_general_text,
  //   SMS_APPLICATION_SUBMIT:`Thank you for choosing  for your financial needs. Your application is being reviewed by one of our bankers. For more information on your loan application, please log onto "${environment.customerJourneyUrl}"`,
  //   SMS_CUSTOMER_CONNECT:`Thank you for choosing  for your financial needs. Your recent query has been responded to by  one of our bankers. Please log onto "${environment.customerJourneyUrl}" to view the same`,
  //   SMS_CREATE_PROFILE:'Thank you for starting your loan application with . Your profile has been confirmed.',
  //   SMS_SEND_CONSENT:'Thank you for choosing  for your financial needs. We are missing some details on your loan application. Kindly check your email for more information on the requirement.'
  // },

  STATUSMAP: {
    '5c20bf7e27105c78ad7f9289': 'Application in Progress',
  },

  RATE_OF_INTREST: {
    under_25: {
      prime: 2.75,
      current: 6.25,
    },
    under_50: {
      prime: 3.75,
      current: 7,
    },
    under_150: {
      prime: 2.75,
      current: 6,
    },
    under_350: {
      prime: 2.75,
      current: 6,
    },
  },

  client_doc_config:{
    "customized": true,
    "customer-primary": "customer-primary",
    "customer-hash": "customer-hash",
    "customer-dashboard": "customer-dashboard"
  },

  DATE_FORMAT: {
    // default_format: 'MM-DD-YYYY',
    // pipe_date_format: 'MM-dd-YYYY',
    default_format: 'DD-MM-YYYY',
    pipe_date_format: 'dd-MM-YYYY',
    pipe_time_format: 'h:mm a',
    pipe_date_and_time_format : 'dd-MM-YYYY/ h:mm a',
    pipe_date_format_1 : 'MM-dd-YYYY'
  },

  CL_GUARANTORS_CONFIG : {
    enabled: true
  },
  CUSTOMER_DECISION:{
    APPROVE:'Approved',
    DECLINE:'Declined',
    SENT:'Sent',
    NOTSENT:'Not Sent'
  }
};
